import { combineReducers } from "redux"
import mobileReducer from "./mobileReducer"
import resourcesReducer from "./resourcesReducer"

export default combineReducers({
    mobile: mobileReducer,
    resources: resourcesReducer
});